<template>
    <div>
        <div>
            <input type="date"
                   class="date-field"
                   v-model="inputDate"
                   :disabled="readOnly || !isActive || isAutoGenerated">
        </div>

        <!--next button-->
        <br>
        <mdbBtn v-show="!readOnly && isActive"
                color="primary"
                class="next-btn"
                name="number"
                id="number"
                :disabled="!hasAnyInput"
                @click="handleAnswer()">
            {{isLastQuestion ? 'Complete' : 'Next'}}
            <mdb-icon v-show="waiting" icon="spinner" :spin="true"/>
        </mdbBtn>
    </div>
</template>

<script>
    import {mdbBtn, mdbIcon} from "mdbvue";

    export default {
        name: "questionTypeDate",
        props: ['question', 'isActive', 'isSubQuestion', 'onDoneFunc', 'isLastQuestion', 'waiting', 'readOnly'],
        components: {
            mdbBtn,
            mdbIcon
        },
        data() {
            return {
                isAutoGenerated: false,
                inputDate: [],
                questionOptions: [],
                showNextButton: false,
                keys: [],
            }
        },
        computed: {
            hasAnyInput() {
                return this.inputDate.length > 0 ? this.showNextButton = true : this.showNextButton = false;
            },


        },

        methods: {
            handleAnswer() {
                if (!this.hasAnyInput) {
                    return;
                }

                const answer = {
                    value: this.inputDate
                };


                this.onDoneFunc(this.question.id, this.questionTypeAnswerId, answer, this.isLastQuestion);
            },
        },
    }
</script>

<style scoped>

</style>
